<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      title="添加"
      width="600px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form label-width="200px" :model="formData" :rules="rules" ref="form">
        <el-form-item label="币种：" prop="coin">
          <el-input v-model="formData.coin" style="width: 180px"></el-input>
        </el-form-item>

        <el-form-item label="实际精度：" prop="actualPrecision">
          <el-input-number
            :precision="0"
            :step="1"
            :min="0"
            v-model.trim="formData.actualPrecision"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="显示精度：" prop="displayPrecision">
          <el-input-number
            :precision="0"
            :step="1"
            :min="0"
            v-model.trim="formData.displayPrecision"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="是否可划转：" prop="isExchange">
          <el-switch
            v-model="formData.isExchange"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>

        <el-form-item label="是否可用：" prop="isOpen">
          <el-switch
            v-model="formData.isOpen"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave('form')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "CreateCurrencyIntroduction",
  data() {
    return {
      dialogVisible: false,
      formData: {
        coin: "",
        actualPrecision: 0,
        displayPrecision: 0,
        isExchange: 0,
        isOpen: 0,
      },
      rules: {
        coin: [{ required: true, message: "请输入币种名称", trigger: blur }],
        actualPrecision: [
          { required: true, message: "请输入实际精度", trigger: blur },
        ],
        displayPrecision: [
          { required: true, message: "请输入显示精度", trigger: blur },
        ],
      },
    };
  },
  components: {},
  methods: {
    ...mapActions("spotCoinAdminStore", ["create"]),
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.create(this.formData).then(() => {
            this.$message.success("添加成功！");
            this.dialogVisible = false;
            this.$emit("refresh", { page: 1 });
          });
        }
      });
    },
    closeDialog() {
      this.formData = {
        coin: "",
        actualPrecision: 0,
        displayPrecision: 0,
        isExchange: 0,
        isOpen: 0,
      };
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped></style>
